export default __webpack_public_path__ + "static/media/md8-ehs.f52d9a17.svg";